export default __webpack_public_path__ + "static/media/box-edge.def4f21b.webp";